<header class="estudio-sidenav--header">
    <div class="estudio-sidenav--arrow">
        <button mat-icon-button class="no-hover-effect menu">
            <mat-icon>arrow_back</mat-icon>
        </button>

    </div>

</header>